export const getCollection = slug => `/api/v1/collections/${slug}?relations=courses`;
export const enrolCollection = hashedId => `/api/v1/member/collections/${hashedId}`;